import React, { FC } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import clsx from "clsx";

import { Button, Divider, Input, Textarea } from "../ui";
import { useAuth } from "../../utils/user-provider";
import { useSendMessagesMutation } from "../../store/api/messages.api";

import styles from "./index.module.css";

type FeedBackFields = {
  email: string;
  name: string;
  message: string;
};

type FeedbackFormProps = {
  title: string;
  withShadow?: boolean;
  package_id?: string;
};

const FeedbackForm: FC<FeedbackFormProps> = (props) => {
  const { title, withShadow, package_id } = props;
  const [sendMessage, { isLoading }] = useSendMessagesMutation();
  const { user } = useAuth();
  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm<FeedBackFields>({
    defaultValues: {
      name: user?.name,
      email: user?.email,
    },
  });

  function handleSubmitFeedbackForm(data: FeedBackFields) {
    sendMessage({ message: data.message, package_id, date_time: Date.now() })
      .unwrap()
      .then(() => {
        toast.success("Сообщение отправлено!", {
          hideProgressBar: true,
          position: "bottom-right",
        });
        reset();
      });
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      <form
        onSubmit={handleSubmit(handleSubmitFeedbackForm)}
        className={styles.form}
      >
        <div
          className={clsx(
            styles.formContent,
            withShadow && styles.formContentWithShadow
          )}
        >
          <div className={styles.inputRow}>
            <div
              className={clsx(styles.inputContainer, styles.inputContainerLeft)}
            >
              <Input
                label="Введите ваш e–mail"
                type="text"
                error={errors.email?.type === "required" && "Поле не заполнено"}
                {...register("email", { required: true })}
              />
            </div>
            <div className={styles.inputDivider} />
            <div className={styles.inputContainer}>
              <Input
                label="Введите ваше имя"
                type="text"
                error={errors.name?.type === "required" && "Поле не заполнено"}
                {...register("name", { required: true })}
              />
            </div>
          </div>
          <Divider />
          <div className={styles.textareaContainer}>
            <Textarea
              label="Введите текст сообщения..."
              error={errors.message?.type === "required" && "Поле не заполнено"}
              {...register("message", { required: true })}
            />
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            type="submit"
            padding={46}
            label="Отправить"
            size="large"
            disabled={isLoading}
          />
        </div>
      </form>
    </div>
  );
};

export default FeedbackForm;
